import React from "react";
import PropTypes from "prop-types";
import styles from "./notificationComponent.module.scss";
import { useDispatch } from "react-redux";
import { getProductByIdResponse } from "../../../store/actions";
import { useNavigate } from "react-router-dom";

const NotificationComponent = ({ notifications = [], onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const normalizedNotifications = Array.isArray(notifications)
    ? notifications
    : [];
  const hasNotifications = normalizedNotifications.length > 0;

  const getStatusLabel = (notification) => {
    if (notification?.quantity === 0) {
      return "OUT OF STOCK";
    }

    if (notification?.quantity > 0 && notification?.quantity <= 5) {
      return "LOW STOCK";
    }

    return "STOCK UPDATE";
  };

  const getWeightLabel = (notification) => {
    if (!notification?.weight) {
      return "-";
    }

    const unit = notification?.siUnit ? ` ${notification.siUnit}` : "";
    return `${notification.weight}${unit}`;
  };

  const handleClick = (item) => {
    dispatch(getProductByIdResponse(item));
    navigate("/products/productdetails");
    onClose();
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Notification</h2>
        <button
          className={styles.closeButton}
          aria-label="Close"
          type="button"
          onClick={onClose}
        >
          ×
        </button>
      </div>

      <div className={styles.listArea}>
        {!hasNotifications && (
          <div className={styles.emptyState}>You are all caught up!</div>
        )}

        {normalizedNotifications.map((notification) => {
          const statusLabel = getStatusLabel(notification);
          return (
            <div
              className={styles.card}
              key={notification?.id || notification?.productCode}
              onClick={() => handleClick(notification)}
            >
              <div className={styles.left}>
                <img
                  src={notification?.imageUrl}
                  alt={notification?.name || "Product"}
                  className={styles.thumbnail}
                />
              </div>

              <div className={styles.right}>
                <div className={styles.topRow}>
                  <span className={styles.reminder}>Reminder:</span>
                  <span className={styles.status}>
                    <span
                      className={styles.statusIcon}
                      role="img"
                      aria-label="alert"
                    >
                      🚨
                    </span>
                    {statusLabel}
                  </span>
                </div>

                <div className={styles.details}>
                  <div className={styles.detailBlock}>
                    <span className={styles.detailLabel}>Product ID</span>
                    <span className={styles.detailValue}>
                      {notification?.productCode || notification?.id || "-"}
                    </span>
                  </div>
                  <div className={styles.detailBlock}>
                    <span className={styles.detailLabel}>Product Name</span>
                    <span className={styles.detailValue}>
                      {notification?.name || "-"}
                    </span>
                  </div>
                  <div className={styles.detailBlock}>
                    <span className={styles.detailLabel}>Quantity</span>
                    <span className={styles.detailValue}>
                      {typeof notification?.quantity === "number"
                        ? notification.quantity
                        : "-"}
                    </span>
                  </div>
                  <div className={styles.detailBlock}>
                    <span className={styles.detailLabel}>Weight</span>
                    <span className={styles.detailValue}>
                      {getWeightLabel(notification)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

NotificationComponent.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.object),
  onClose: PropTypes.func,
};

NotificationComponent.defaultProps = {
  notifications: [],
  onClose: () => {},
};

export default NotificationComponent;
